import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { defaults, Pie } from 'react-chartjs-2';
import Color from 'color';

//import logo from '../../assets/images/logos/Logo-Color@2x.png';
//import logo from '../../assets/images/logos/Bechtel-Logo-650.png';
import logo from '../../assets/images/logos/Westinghouse-Icon.png';

import {
  toTitleCase,
  colorForCategory,
  getScoreClassificationInOrderedGroupScores,
} from '../../util';
import {
  getOrderedUserStrengthsFromAllScores,
  getUserDataFromAllUsers,
  getUserCompetitiveAdvantages
} from '../../util/data';
import {
  introForPlanYourCareer,
  introForPlayToYourStrengths,
  descriptionForPlayToStrengthsTalent,
  descriptionForPlayToStrengthsCategory,
  descriptionForTalentCategoryStrength,
  descriptionForTalentCategoryWeakness,
  descriptionForTalent,
  descriptionForTalentCategory,
  descriptionForCompetency,
  descriptionForPlayToStrengthsTalentCategory,
} from '../../util/westinghouseDescriptions';
import { iconForTalentCategory } from '../../util/icons';

const PAGE_OFFSET = 2;

//const LOGO_WIDTH = "150";
//const LOGO_HEIGHT = "40";
const LOGO_WIDTH = "50";
const LOGO_HEIGHT = "50";

// Disable animating charts by default.
defaults.pie.animation.animateRotate = false;
defaults.pie.animation.animateScale = false;
defaults.global.tooltips.enabled = false;
//defaults.global.elements.arc.borderWidth = 0;
defaults.global.elements.arc.backgroundColor = 'rgba(0,0,0,.1)';

const TALENT_CATEGORIES=[{
  name: 'Motivation',
  id: 'motivation'
},{
  name: 'Interaction',
  id: 'interaction'
},{
  name: 'Execution',
  id: 'execution'
},{
  name: 'Cognition',
  id: 'cognition'
}];

class CompetitiveAdvantageReport extends Component {

  state = {
    ProfileID: null
  }

  componentWillMount(){
    const { match: { params } } = this.props;

    this.setState({
      ProfileID: params.ProfileID
    });
  }
  componentDidMount(){
    console.log('bechtel competitive advantage props: ', this.props);
  }

  renderLoadingMessage(){
    return <p>Loading...</p>;
  }

  dataForProfile(){

    const ProfileID = this.state.ProfileID;

    console.log(`data for profile ${ProfileID} calculating...`);

    const userData = _.find(this.props.users, {_id: ProfileID} );

    console.log('userData: ', userData);

    if(!userData){
      return null;
    }

    const strengths = getOrderedUserStrengthsFromAllScores(userData);

    console.log('strengths: ', strengths);

    if(!strengths){
      return null;
    }

    return {
      user: userData,
      strengths: strengths,
    }
  }

  componentWillReceiveProps(nextProps){
    console.log('bechtel competitive advantage page nextProps: ', nextProps);

    //TEMP code used to calculate map for users w/ and w/o Competitive Advantages
    // console.log('calculating users w/ competitve advantage');
    //
    // let usersAdvantagesMap = {};
    // _.each(nextProps.users, user => {
    //   const advantages = getUserCompetitiveAdvantages(user);
    //
    //   usersAdvantagesMap[user._id] = advantages.length > 0;
    // });
    //
    // console.log('usersAdvantagesMap: ', usersAdvantagesMap);
  }

  renderFooterForPage(pageNumber){
    return (
      <div className="page-footer">
        {this.renderPreparedForUser()}
        {this.renderPageNumber(pageNumber)}
      </div>
    )
  }

  renderPreparedForUser(){
    const dataForProfile = this.dataForProfile();

    const {FirstName, LastName} = dataForProfile.user;

    return (
      <div className="prepared-for">Prepared for {FirstName} {LastName}</div>
    )
  }

  renderPageNumber(number){
    return (
      <div className="page-marker">Page {number}</div>
    )
  }

  renderTalent(talent){

    const talentDescription = descriptionForTalent(talent.id);

    const percentAboveBenchmark = Math.round(((talent.score / talent.benchmark) - 1) * 100.);

    return (
      <li key={talent.id}>
        <h4>{toTitleCase(talent.id)}</h4>
        <div className="above-benchmark"><small>+</small>{percentAboveBenchmark}<small>%</small></div>
        <div className="benchmark-explanation">above top performers</div>
        <p>{talentDescription}</p>
      </li>
    );
  }

  renderCompetitiveAdvantages(dataForProfile){

    const role = dataForProfile.user['FiveRoles'];

    let competitiveAdvantageExplanation = '';

    switch(role){
      case 'RVP/MD':
        competitiveAdvantageExplanation = 'As a Regional VP / Managing Director, your individual scores on each of the high-performance competencies were compared to the Global World Class Benchmark, which is the mean average of Exemplar Performers in similar Regional VP / Managing Director roles in the Velocity database.  While the below competencies may not be your personal Top Strengths, these are the Competencies where you outscored the best and have a Competitive Advantage when compared to your peers.';
        break;
      case 'KAVP':
        competitiveAdvantageExplanation = 'As a Key Account VP, your individual scores on each of the high-performance competencies were compared to the Global World Class Benchmark, which is the mean average of Exemplar Performers in similar Key Account VP roles in the Velocity database.  While the below competencies may not be your personal Top Strengths, these are the Competencies where you outscored the best and have a Competitive Advantage when compared to your peers.';
        break;
      case 'CAD/CAM':
        competitiveAdvantageExplanation = 'As a Customer Account Manager / Director, your individual scores on each of the high-performance competencies were compared to the Global World Class Benchmark, which is the mean average of Exemplar Performers in similar Customer Account Manager / Director roles in the Velocity database.  While the below competencies may not be your personal Top Strengths, these are the Competencies where you outscored the best and have a Competitive Advantage when compared to your peers.';
        break;
      case 'CAE':
        competitiveAdvantageExplanation = 'As a Customer Account Engineer, your individual scores on each of the high-performance competencies were compared to the Global World Class Benchmark, which is the mean average of Exemplar Performers in similar Customer Account Engineer roles in the Velocity database.  While the below competencies may not be your personal Top Strengths, these are the Competencies where you outscored the best and have a Competitive Advantage when compared to your peers.';
        break;
      case 'RSM':
        competitiveAdvantageExplanation = 'As a Resident Site Manager, your individual scores on each of the high-performance competencies were compared to the Global World Class Benchmark, which is the mean average of Exemplar Performers in similar Resident Site Manager roles in the Velocity database.  While the below competencies may not be your personal Top Strengths, these are the Competencies where you outscored the best and have a Competitive Advantage when compared to your peers.';
        break;
      default:
        competitiveAdvantageExplanation = 'Your individual scores on each of the high-performance competencies were compared to the Global World Class Benchmark, which is the mean average of Exemplar Performers in similar roles in the Velocity database.  While the below competencies may not be your personal Top Strengths, these are the Competencies where you outscored the best and have a Competitive Advantage when compared to your peers.';
        break;
    }

    const talentsAboveBenchmark = getUserCompetitiveAdvantages(dataForProfile.user);

    return (
      <React.Fragment>
        <p style={{width: '100%'}}>{competitiveAdvantageExplanation}</p>
        <ul className="benchmarks">
          {_.map(talentsAboveBenchmark, this.renderTalent.bind(this))}
        </ul>
      </React.Fragment>
    )
  }

  renderCompetitiveAdvantageReport(dataForProfile){

    const talentsAboveBenchmark = getUserCompetitiveAdvantages(dataForProfile.user);

    //if no talents above benchmark...
    if(talentsAboveBenchmark.length === 0){
      return (
        <div className="page report-export">
          <div className="report-know-your-strengths report-page">
            <h1>&nbsp;</h1>
            <img className="report-logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} src={logo} />
            {dataForProfile && this.renderFooterForPage(1 + PAGE_OFFSET)}
          </div>
        </div>
      );
    }
    else{
      return (
        <div className="page report-export">
          <div className="report-know-your-strengths report-page">
            <img className="report-logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} src={logo} />
            <h1 style={{width: '100%'}}>Your Competitive Advantage<br/><span className="prepared-for" style={{textTransform: 'capitalize'}}>{dataForProfile.user.FirstName + ' ' + dataForProfile.user.LastName}</span></h1>
            {dataForProfile && this.renderCompetitiveAdvantages(dataForProfile)}
            {dataForProfile && this.renderFooterForPage(1 + PAGE_OFFSET)}
          </div>

          {!dataForProfile && this.renderLoadingMessage()}
        </div>
      );
    }
  }

  render(){

    const dataForProfile = this.dataForProfile();

    console.log('main render');
    console.log('users: ', this.props.users);
    console.log('dataForProfile: ', dataForProfile);

    if(!dataForProfile || !dataForProfile.user){
      return null;
    }

    return this.renderCompetitiveAdvantageReport(dataForProfile);
  }
}

function mapStateToProps(state){
  return {
    users: state.users,
  }
}

export default connect(mapStateToProps, {})(CompetitiveAdvantageReport);



// WEBPACK FOOTER //
// ./src/components/report_deprecated/competitiveAdvantage.js